var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
var Int = /** @class */ (function (_super) {
    __extends(Int, _super);
    /**
     * @param minValue Минимальное значение
     */
    function Int(minValue) {
        var _this = _super.call(this) || this;
        _this._minValue = minValue;
        return _this;
    }
    Int.prototype.encodeBuffer = function (value, buffer) {
        if (typeof value !== 'number') {
            throw new TypeError('value must be a number');
        }
        if (typeof this._minValue === 'number') {
            value -= this._minValue;
            if (value < 0) {
                throw new RangeError('value must be >= minValue');
            }
        }
        else {
            if (value < 0) {
                value = -value * 2 + 1;
            }
            else {
                value *= 2;
            }
        }
        while (value > 31) {
            buffer.write(32 + (value % 32));
            value = Math.floor(value / 32);
        }
        buffer.write(value);
    };
    Int.prototype.decodeBuffer = function (buffer) {
        var byte;
        var value = 0;
        var mult = 1;
        do {
            byte = buffer.read();
            value += (byte % 32) * mult;
            mult *= 32;
        } while (byte > 31);
        if (typeof this._minValue === 'number') {
            value += this._minValue;
        }
        else {
            if (value % 2) {
                value = (1 - value) / 2;
            }
            else {
                value /= 2;
            }
        }
        return value;
    };
    return Int;
}(Type));
export { Int };
